import React from "react";
import { Outlet, Navigate, useLocation } from "react-router";
import { isAuthenticated } from "@nusrif/services";

export const ProtectedLayout: React.FC = () => {
  const location = useLocation();

  if (!isAuthenticated()) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?returnUrl=${returnUrl}`} replace />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Outlet />
    </div>
  );
};
